module.exports = __webpack_public_path__ + "media/images/partner/supporter/not_approved/bank_fuer_sozialwirtschaft-ee0d1f2299dc45f3e9bd7b38f0ac63e0.png";